var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isActivePWA)?[_c('SearchBarPwa',{staticClass:"searchBarPwa"})]:[_c('SearchBarDesktop',{staticClass:"searchBarDesktop"}),_c('SearchBarMobile',{staticClass:"searchBarMobile"})],_c('PortalTarget',{attrs:{"name":"sai-modal","slim":""}}),_c('PortalTarget',{attrs:{"name":"sai-dropdown-options","slim":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }